// src/data/Menu.js or wherever you keep it
export const MENUITEMS = [
  {
    Items: [
      {
        title: "Dashboard",
        key: "dashboard",
        icon: "bi bi-house-fill",
        type: "link",
        path: `${process.env.PUBLIC_URL}/dashboard`,
      },
      {
        title: "Master",
        key: "master",
        icon: "bi bi-files",
        type: "sub",
        children: [
          { path: `${process.env.PUBLIC_URL}/unit-list`, title: "Unit Management", type: "link" },
          { path: `${process.env.PUBLIC_URL}/department-list`, title: "Department Management", type: "link" },
          { path: `${process.env.PUBLIC_URL}/sample-list`, title: "Sample Management", type: "link" },
          { path: `${process.env.PUBLIC_URL}/test-method-list`, title: "Test Method", type: "link" },
          { path: `${process.env.PUBLIC_URL}/parameter-list`, title: "Parameter", type: "link" },
        ],
      },
      {
        title: "Manage Test",
        key: "manage-test",
        icon: "bi bi-clipboard2-pulse-fill",
        type: "sub",
        children: [
          { path: `${process.env.PUBLIC_URL}/list-test`, title: "Lab Tests", type: "link" },
          { path: `${process.env.PUBLIC_URL}/package-list`, title: "Lab Test Packages", type: "link" },
        ],
      },
      {
        title: "Manage Customer",
        key: "manage-customer",
        icon: "bi bi-person-fill",
        type: "sub",
        children: [
          { path: `${process.env.PUBLIC_URL}/patient-list`, title: "Lab Customer", type: "link" },
          { path: `${process.env.PUBLIC_URL}/ledger`, title: "Ledger", type: "link" },
        ],
      },
      {
        title: "Manage Doctors",
        key: "manage-doctors",
        icon: "bi bi-people-fill",
        type: "link",
        path: `${process.env.PUBLIC_URL}/doctors-list`,
      },
      {
        title: "New Test",
        key: "new-test",
        icon: "bi bi-file-earmark-font-fill",
        type: "link",
        path: `${process.env.PUBLIC_URL}/search-patient`,
      },
      {
        title: "Test Report",
        key: "test-report",
        icon: "bi bi-file-earmark-pdf-fill",
        type: "link",
        path: `${process.env.PUBLIC_URL}/test-list`,
      },
      {
        title: "Transactions",
        key: "transaction",
        icon: "bi bi-credit-card-fill",
        type: "link",
        path: `${process.env.PUBLIC_URL}/transcation`,
      },
      {
        title: "Pay-In & Pay-Out",
        key: "pay-in-out",
        icon: "bi bi-cash",
        type: "link",
        path: `${process.env.PUBLIC_URL}/pay`,
      },
      {
        title: "Lab User",
        key: "lab-user",
        icon: "bi bi-people",
        type: "link",
        path: `${process.env.PUBLIC_URL}/user`,
      },
      {
        title: "Collection",
        key: "collection",
        icon: "bi bi-collection-fill",
        type: "link",
        path: `${process.env.PUBLIC_URL}/collection`,
      },
      {
        title: "Setting",
        key: "setting",
        icon: "bi bi-gear-fill",
        type: "sub",
        children: [
          { path: `${process.env.PUBLIC_URL}/header-setting`, title: "Header Setting", type: "link",key: "header-setting" },
          { path: `${process.env.PUBLIC_URL}/footer-setting`, title: "Footer Setting", type: "link",key: "footer-setting" },
          // { path: `${process.env.PUBLIC_URL}/conversion-setting`, title: "Conversion Setting", type: "link" },
          { path: `${process.env.PUBLIC_URL}/setting`, title: "Signature Setting", type: "link" },
        ],
      },
    ],
  },
];